import { render, staticRenderFns } from "./PrimaryButtonAnimated.vue?vue&type=template&id=48803a1a&scoped=true&"
import script from "./PrimaryButtonAnimated.vue?vue&type=script&lang=js&"
export * from "./PrimaryButtonAnimated.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryButtonAnimated.vue?vue&type=style&index=0&id=48803a1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48803a1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
